var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.721,
    height: 12.721,
    viewBox: "0 0 12.721 12.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M0,0H12.721V12.721H0Z",
    transform: "translate(0)",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M6.374,7.072A5.6,5.6,0,0,0,8.469,9.166l.469-.656a.53.53,0,0,1,.686-.157,6.054,6.054,0,0,0,2.429.723.53.53,0,0,1,.488.528V11.97a.53.53,0,0,1-.476.527A8.22,8.22,0,0,1,3.043,3.476.53.53,0,0,1,3.571,3H5.936a.53.53,0,0,1,.528.488,6.054,6.054,0,0,0,.723,2.429A.53.53,0,0,1,7.03,6.6ZM5.037,6.723,6.044,6A7.108,7.108,0,0,1,5.463,4.06h-1.4c0,.088,0,.176,0,.265a7.154,7.154,0,0,0,7.155,7.155c.089,0,.177,0,.265-.005v-1.4A7.108,7.108,0,0,1,9.536,9.5L8.817,10.5a6.594,6.594,0,0,1-.842-.4l-.031-.017A6.655,6.655,0,0,1,5.452,7.6l-.017-.031a6.594,6.594,0,0,1-.4-.842Z",
    transform: "translate(-1.41 -1.41)",
    fill: "#09c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9b800b3e160f0605f481bd6d2cf62c2a.svg";
export { ForwardRef as ReactComponent };